export enum AbbriviatedCurrency {
  kr = 'kr',
  '€' = '€',
}
